/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Legacy
 * Mercatus Legacy ILM
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { InlineResponse2007 } from '../model';
// @ts-ignore
import { InlineResponse2008 } from '../model';
// @ts-ignore
import { InlineResponse2009 } from '../model';
/**
 * CalculationLogApi - axios parameter creator
 * @export
 */
export const CalculationLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary changes status of calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {string} status status of the batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatusOfBatchCalculation: async (batchId: number, status: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('changeStatusOfBatchCalculation', 'batchId', batchId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changeStatusOfBatchCalculation', 'status', status)
            const localVarPath = `/projects/changeStatusOfBatchCalculation/{batchId}/{status}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationBatchDetails: async (batchId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getCalculationBatchDetails', 'batchId', batchId)
            const localVarPath = `/projects/detailStatusOfBatchCalculation/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets calculation log batches
         * @param {string} [status] Optional status of batch
         * @param {string} [category] Optional category ( entity type )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationBatches: async (status?: string, category?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects/statusOfBatchCalculation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationLogApi - functional programming interface
 * @export
 */
export const CalculationLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary changes status of calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {string} status status of the batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStatusOfBatchCalculation(batchId: number, status: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStatusOfBatchCalculation(batchId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationBatchDetails(batchId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalculationBatchDetails(batchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets calculation log batches
         * @param {string} [status] Optional status of batch
         * @param {string} [category] Optional category ( entity type )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationBatches(status?: string, category?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalculationBatches(status, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CalculationLogApi - factory interface
 * @export
 */
export const CalculationLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationLogApiFp(configuration)
    return {
        /**
         * 
         * @summary changes status of calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {string} status status of the batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatusOfBatchCalculation(batchId: number, status: string, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.changeStatusOfBatchCalculation(batchId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets calculation log details of a batch
         * @param {number} batchId batchId of detail log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationBatchDetails(batchId: number, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.getCalculationBatchDetails(batchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets calculation log batches
         * @param {string} [status] Optional status of batch
         * @param {string} [category] Optional category ( entity type )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationBatches(status?: string, category?: string, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.getCalculationBatches(status, category, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationLogApi - object-oriented interface
 * @export
 * @class CalculationLogApi
 * @extends {BaseAPI}
 */
export class CalculationLogApi extends BaseAPI {
    /**
     * 
     * @summary changes status of calculation log details of a batch
     * @param {number} batchId batchId of detail log
     * @param {string} status status of the batch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationLogApi
     */
    public changeStatusOfBatchCalculation(batchId: number, status: string, options?: any) {
        return CalculationLogApiFp(this.configuration).changeStatusOfBatchCalculation(batchId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets calculation log details of a batch
     * @param {number} batchId batchId of detail log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationLogApi
     */
    public getCalculationBatchDetails(batchId: number, options?: any) {
        return CalculationLogApiFp(this.configuration).getCalculationBatchDetails(batchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets calculation log batches
     * @param {string} [status] Optional status of batch
     * @param {string} [category] Optional category ( entity type )
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationLogApi
     */
    public getCalculationBatches(status?: string, category?: string, options?: any) {
        return CalculationLogApiFp(this.configuration).getCalculationBatches(status, category, options).then((request) => request(this.axios, this.basePath));
    }
}
